<template>
  <div class="select-dialog" v-if="dialogVisible">
    <div class="modal-content">
      <div class="content-title">
        {{modalTitle}}
        <i class="el-icon-close custom-style" @click="cancel"></i>
      </div>
      <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
      <div class="tree-wrapper">
        <el-tree
          class="filter-tree"
          :data="data"
          :props="defaultProps"
          :highlight-current="true"
          :check-on-click-node="true"
          @node-click="nodeClick"
          :filter-node-method="filterNode"
          ref="tree2"
        ></el-tree>
      </div>
      <div class="confirm-btn">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
    <div class="modal-mask" @click="cancel"></div>
  </div>
</template>
<script>
export default {
  name: "select-dialog",
  props: {
    modalTitle: String,
    defaultProps: Object,
    data: Array,
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterText: "",
      selectItem: {}
    };
  },
  created() {},
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    }
  },
  methods: {
    cancel() {
      this.filterText = ''
      this.$emit("cancel");
    },
    confirm() {
      if (this.selectItem.childNodes && this.selectItem.childNodes.length > 0) {
        this.$message.error(`请选择正确的${this.modalTitle}`);
        return;
      }
      this.filterText = ''
      console.log(this.selectItem.data);
      this.$emit("confirm-select-item", this.selectItem);
    },
    filterNode(value, data, node) {
      //   console.log(value);
      //   console.log(2222);
      //   if (!value) return true;
      //   return data.label.indexOf(value) !== -1;
      // 如果什么都没填就直接返回
      if (!value) return true;
      var searchName = this.defaultProps.searchName
        ? this.defaultProps.searchName
        : [].concat([this.defaultProps.label]);
      if (searchName) {
        var len = searchName.length;
        if (len > 0) {
          for (let i = 0; i < len; i++) {
            if (data[searchName[i]].indexOf(value) !== -1) {
              return true;
            }
          }
        }
      }
      // 否则要去判断它是不是选中节点的子节点
      return this.checkBelongToChooseNode(value, data, node, searchName);
    },
    // 判断传入的节点是不是选中节点的子节点
    checkBelongToChooseNode(value, data, node, searchName) {
      const level = node.level;
      // 如果传入的节点本身就是一级节点就不用校验了
      if (level === 1) {
        return false;
      }
      // 先取当前节点的父节点
      let parentData = node.parent;
      // 遍历当前节点的父节点
      let index = 0;
      while (index < level - 1) {
        if (searchName && searchName.length > 0) {
          var len = searchName.length;
          for (let i = 0; i < len; i++) {
            if (parentData.data[searchName[i]].indexOf(value) !== -1) {
              return true;
            }
          }
        }
        // 否则的话再往上一层做匹配
        parentData = parentData.parent;
        index++;
      }
      // 没匹配到返回false
      return false;
    },
    nodeClick(data, node) {
      if (node.level === 1) {
        const children = node.childNodes
        // 按目前数据情况，只做了点击一级展开所有二级
        children.length > 0 && children.map(child => {
          child.expanded = true;
        })
      }
      this.selectItem = node;
    }
  }
};
</script>
<style type="text/scss" lang="scss" scoped>
.select-dialog {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  .modal-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 80%;
    z-index: 999;
    transform: translate(-50%, 18%);
    margin-left: 50%;
    padding: 15px 15px 8px 15px;
    background-color: #fff;
    border: 1px solid #e3e3e3;
    border-radius: 10px;

    .content-title {
      padding: 14px 0;
      .custom-style {
        position: absolute;
        right: 10px;
        top: 10px;
        color: #888;
      }
    }
    .tree-wrapper {
      height: 420px;
      border: 1px solid #f3f3f3;
      margin: 10px 0;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    .confirm-btn {
      padding: 6px 0;
      text-align: center;
    }
  }
  .modal-mask {
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/components/select-dialog.vue